module.exports = __webpack_public_path__ + "static/media/Hourglass.8cfb9ded.svg";